import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Cobertura',
    href: '#cobertura'
  }, {
    name: 'Portafolio',
    href: '#portafolio'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-espresso/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-150" data-mp="1pxrtu195n8zr">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-151" data-mp="epdndx8t31vv">
        <a href="#" className="block" data-id="element-152" data-mp="jkkkgm7kl8bt">
          <Logo variant="dark" size="sm" data-id="element-153" data-mp="om9y89m6g03l" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-154" data-mp="3n3m9qnkqiwfl">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-bone/80 hover:text-gold transition-colors" data-id="element-155" data-mp="3s279klw2re3i">
              {link.name}
            </a>)}
          <a href="#contacto" className="px-5 py-2 text-sm font-medium text-espresso bg-gold hover:bg-gold-light transition-colors rounded-sm" data-id="element-156" data-mp="5nnxwwyhid0q">
            Asesoría
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-bone" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-157" data-mp="31b03aqlfiov8">
          {isMobileMenuOpen ? <X size={24} data-id="element-158" data-mp="3b132x9n2312j" /> : <Menu size={24} data-id="element-159" data-mp="3b1mabwf2y72b" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-espresso border-t border-white/10 mt-4" data-id="element-160" data-mp="361qa889i6zs1">
          <div className="px-6 py-4 flex flex-col space-y-4" data-id="element-161" data-mp="2s8ihuedlm09a">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-bone/80 hover:text-gold transition-colors py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-162" data-mp="2ndv0r0kxc84q">
                {link.name}
              </a>)}
          </div>
        </motion.div>}
    </motion.nav>;
}